"use client";
import AllAppsList from "@/components/apps/all-apps";

function Work() {
  return <AllAppsList />;
}

export default Work;
